import React, { createContext, useContext, useState, useEffect } from "react";
import { io } from "socket.io-client";

import { refreshTokenApi } from "@/api/auth";
import { SOCKET_URL } from "@/config/vars";
import { getLocalUserData } from "@/utils";

const SocketContext = createContext(null);

// Socket Hook
export const useSocket = () => {
  return useContext(SocketContext);
};

// Socket Provider Initialization
export const SocketProvider = ({ initialAccessToken, existingRefreshToken, children }) => {
  const [token, setToken] = useState(initialAccessToken);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const newSocket = io(SOCKET_URL, {
      auth: { token },
      transports: ["websocket"],
    });

    newSocket.on("connect", () => {
      console.log("Connected to Socket.IO server");
    });

    newSocket.on("connect_error", async (err) => {
      try {
        if (err.message === "Invalid Token.") {
          const userData = getLocalUserData();

          const { access_token } = await refreshTokenApi({ refresh_token: userData.refresh_token });
          setToken(access_token);
          newSocket.auth = { token: access_token };
          newSocket.connect();
        }
        // Get new access token on expiry
      } catch (error) {
        console.log(error);
      }
    });

    newSocket.connect();
    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, [token, existingRefreshToken]);

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};
